// @ts-nocheck
import React, { useState, useEffect, useContext } from 'react';
import Router from 'next/router';
import { useQuery } from '@tanstack/react-query';
import SCInput from '@/components/sc-controls/form-controls/sc-input';
import Button from '@/components/button';
import Breadcrumbs from '@/components/breadcrumbs';
import { colors, fontSizes, layout, fontFamily, shadows } from '@/theme';
import Fetch from '@/utils/Fetch';
import ToastContext from '@/utils/toast-context';
import SettingsMenu from '@/components/settings/menu';
import Helper from '@/utils/helper';
import ConfirmAction from '@/components/modals/confirm-action';
import Storage from '@/utils/storage';
import * as Enums from '@/utils/enums';
import { createFileRoute } from '@tanstack/react-router'



function PayFast() {

    const toast = useContext(ToastContext);

    let currentPath = "";
    if (Router.router) {
        currentPath = Router.router.asPath;
    }

    //const [formIsDirty, setFormIsDirty] = useState(false);    

    const [confirmOptions, setConfirmOptions] = useState(Helper.initialiseConfirmOptions());


    const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

    const getAccessStatus = () => {
        let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
        if (subscriptionInfo) {
            setAccessStatus(subscriptionInfo.AccessStatus);
        }
    };
    
    useEffect(() => {
        getAccessStatus();
    }, []);

    const { data: integrationData } = useQuery(
        ['payfastIntegration'],
        () => Fetch.get({
            url: `/Integration/GetIntegration`,
            params: {
                integrationPartner: Enums.IntegrationPartner.PayFast,
                integrationType: Enums.IntegrationType.PaymentGateway,
            },
        })
    );

    useEffect(() => {
        if (integrationData && !isNaN(parseInt(integrationData?.Status))) {
            setIntegration(integrationData);
        }
    }, [integrationData]);

    const [integration, setIntegration] = useState({
        PartnerTenantID: '',
        Status: Enums.IntegrationStatus.Unspecified,
    });

    const [partnerTenantID, setPartnerTenantID] = useState('');
    const [integrationStatus, setIntegrationStatus] = useState(Enums.IntegrationStatus.Unspecified);

    useEffect(() => {
        if (integration) {
            // check on status to get what to show
            setIntegrationStatus(integration.Status);
            setPartnerTenantID(integration.PartnerTenantID);
        }
    }, [integration]);

    const [inputErrors, setInputErrors] = useState<any>({});

    const handlePartnerTenantIDChange = (e: any) => {
        setIntegration({...integration, PartnerTenantID: e.value});
    };    

    const validate = () => {
        let validationInputs = [
            { key: 'PartnerTenantID', value: integration.PartnerTenantID, required: true, type: Enums.ControlType.Text, error: "Credentials required to activate payment provider" },
        ];
        const { isValid, errors } = Helper.validateInputs(validationInputs);
        setInputErrors(errors);

        return isValid;
    };

    const activate = () => {
        performActivation(false);
    };

    const reactivate = () => {
        performActivation(true);
    };

    async function performActivation(reactivate = false) {
        let isValid = validate();

        if (isValid) {
            let result = await Fetch.post({
                url: `/Integration/ActivatePaymentProvider`,
                params: {
                    integrationPartner: Enums.IntegrationPartner.PayFast,
                    integrationType: Enums.IntegrationType.PaymentGateway,
                    partnerTenantID: partnerTenantID,
                },
                toastCtx: toast,
              });

              if (result.ID) {
                toast.setToast!!!({
                    message: `Payfast ${reactivate ? 'reactivated' : 'activated'} successfully`,
                    show: true,
                    type: 'success'
                });
                setIntegration(result);
              }
        } else {
            toast.setToast!!!({
                message: 'There are errors on the page',
                show: true,
                type: 'error',
            });
        }
    }

    const confirmDeactivate = async () => {
        setConfirmOptions({
          display: true,
          heading: "Deactivate Account",
          text: `Are you sure you want to deactivate your PayFast account?`,
          confirmButtonText: "Yes",
          showCancel: true,
          onConfirm: async () => {
            deactivate();
          }
        });
    };

    async function deactivate() {
        let result = await Fetch.post({
            url: `/Integration/DeactivatePaymentProvider`,
            params: {
                integrationPartner: Enums.IntegrationPartner.PayFast,
                integrationType: Enums.IntegrationType.PaymentGateway,
            },
            toastCtx: toast,
        });

        if (result.ID) {
            toast.setToast!!!({
                message: `Payfast deactivated successfully`,
                show: true,
                type: 'success'
            });
            setIntegration(result);
        }
    }

    const payfastSignup = () => {
        Helper.openUrlInNewTab("https://www.payfast.co.za/registration");
    };

    const payfastLogin = () => {
        Helper.openUrlInNewTab("https://my.payfast.co.za/login");
    };

    return (
        <div className='settings-container'>
            {/*<div className="row">
                <div className="title">
                    <Breadcrumbs
                        crumbs={[
                        { text: 'Settings', link: '/settings', suppressLink: true },
                        { text: 'Payfast', link: '/settings/payment/payfast' },
                        ]}
                    />
                </div>
            </div>*/}
            <div className='row'>
                <SettingsMenu urlPath={currentPath} />
                <div className='settings-card'>
                    <h3>PayFast Payment Gateway</h3>
                    <p>Get paid faster and maximise cashflow. Set up PayFast for customers to pay directly from invoices.</p>
                    <hr/>
                    <h3>Account Information</h3>
                    <SCInput error={inputErrors.PartnerTenantID} required={true} extraClasses="input-width"
                        value={partnerTenantID} label="Merchant ID" onChange={handlePartnerTenantIDChange} />

                    {integrationStatus == Enums.IntegrationStatus.Unspecified ?
                        <Button text="Activate PayFast" onClick={() => activate()} extraClasses="fit-content" /> : ''
                    }

                    {integrationStatus == Enums.IntegrationStatus.Live ?
                        <Button text="Deactivate PayFast" onClick={() => confirmDeactivate()} extraClasses="fit-content grey-action" /> : ''
                    }

                    {integrationStatus == Enums.IntegrationStatus.Cancelled ?
                        <Button text="Reactivate PayFast" onClick={() => reactivate()} extraClasses="fit-content" /> : ''
                    }

                    <div className='signup-container'>
                        <span className='signup-text'>Don't have a PayFast account?</span>
                        <span className='link' onClick={payfastSignup}>&nbsp;Sign up</span>
                    </div>

                    <p>Where is my PayFast Merchant ID?</p>

                    <div className='merchant-container'>
                        Your Merchant ID can be found in the left corner of your&nbsp;
                        <span className='link' onClick={payfastLogin}>PayFast Dashboard.</span>
                    </div>
                </div>
            </div>

            <ConfirmAction options={confirmOptions} setOptions={setConfirmOptions} />

            <style jsx>{`
                .row {
                    display: flex;
                    justify-content: space-between;
                }
                .column {
                    display: flex;
                    flex-direction: column;
                    width: ${layout.inputWidth};
                }
                  
                .title {
                    color: ${colors.darkPrimary};
                    position: relative;
                    width: 100%;
                }
                .title h1 {
                    font-size: 24px;
                    margin: 6px 0 2rem 0;
                }
                .title p {
                    font-size: 14px;
                    margin: 0;
                }                               
                .container :global(.input-container) {
                    width: 50%;
                }
                .title :global(.save) {
                    margin: 0;
                    position: absolute;
                    right: 0;
                    top: 0;
                }
                .signup-container {
                    color: ${colors.labelGrey};
                    font-size: 12px;
                    margin-top: 1rem;
                    margin-bottom: 1rem;
                }
                .signup-text {
                    color: ${colors.labelGrey};
                }
                .link {
                    color: ${colors.bluePrimary};
                    cursor: pointer;
                }
                .merchant-container {
                    color: ${colors.labelGrey};
                    max-width: 684px;
                    line-height: 20px;
                    font-size: 14px;
                }
            `}</style>
        </div>
    )
}

export default PayFast;

export const Route = createFileRoute('/_authenticated/settings/payment/payfast')({ component: PayFast })
